import React, { useState, useEffect, useCallback } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Wrapper, Map, WrapperMap, WrapperScroller, ColMap } from './style.css'

import Mapa from '../Mapa'
import Scroller from '../Scroller'
import Numbers from '../Mapa/Numbers'

const Composer = () => {
  const { allGoogleSpreadsheetUnificadoUnificado } = useStaticQuery(graphql`
    query ViolenciaQuery($formatString: String = "") {
      allGoogleSpreadsheetUnificadoUnificado {
        nodes {
          fecha(formatString: $formatString)
          comuna
          regi_n
          formalizados
          estadoDeLaCausa
          latitud
          longitud
          polic_aACargo
          rit
          ruc
          sector
          tribunal
          delitos
        }
      }
    }
  `)

  const { nodes } = allGoogleSpreadsheetUnificadoUnificado

  const [visibles, setVisibles] = useState([])
  const [allVisibles, setAllVisibles] = useState([])
  const [acumulados, setAcumulados] = useState([])
  const [epoca, setEpoca] = useState()

  const semestreTitulo = texto => {
    return `${texto.endsWith('2') ? 'Segundo Semestre' : 'Primer Semestre'} ${
      texto.split('-')[0]
    } `
  }

  const generateDates = fecha => {
    const date = new Date(fecha)
    const year = date.getFullYear()
    const semester = Math.floor(date.getMonth() / 6) + 1
    return { year, semester }
  }

  const groupBySemester = list => {
    return list.reduce((group, node) => {
      const { year, semester } = generateDates(node.fecha)
      const groupKey = `${year}-${semester}`
      ;(group[groupKey] = group[groupKey] || []).push({
        ...node,
        year,
        semester,
      })
      return group
    }, {})
  }

  const semestres = groupBySemester(nodes)

  const selectPastSemestres = (nodes, actualSemesterKey) => {
    const arr = Object.keys(nodes)
    const fromindex = arr.findIndex(item => item === actualSemesterKey)
    arr.splice(fromindex, arr.length - fromindex)
    const out = []
    arr.map(key => {
      out.push(...nodes[key])
    })
    return out
  }

  const handleVisible = key => {
    setAcumulados(selectPastSemestres(semestres, key))
    // setIncidentesAcumulados()
    setEpoca(semestreTitulo(key))
    setVisibles([...semestres[key]])
    setAllVisibles([])
  }

  const extractAllNodesFromSemestres = nodes => {
    const out = []
    Object.keys(nodes).map(node => {
      out.push(...nodes[node])
    })
    return out
  }

  const handleAllVisible = () => {
    setAcumulados([])
    setEpoca('Todos los incidentes 2016-2021')
    setVisibles([])
    setAllVisibles(extractAllNodesFromSemestres(semestres))
  }

  const calculateComunas = nodes => {
    const comunas = []
    nodes.map(node => {
      comunas.push(node.comuna)
    })
    const unique = [...new Set(comunas)]
    return unique.length
  }

  const [comunasAfectadas, setComunasAfectadas] = useState(0)
  const [allComunasAfectadas, setAllComunasAfectadas] = useState(0)
  const [triggeredNode, setTriggeredNode] = useState(false)
  const [resetMapView, setResetMapView] = useState(false)
  const [mapViewToAllVisibles, setMapViewToAllVisibles] = useState(false)
  const [globalMode, setGlobalMode] = useState(false)

  useEffect(() => {
    const localCalc = calculateComunas(visibles)
    if (localCalc !== comunasAfectadas) {
      setComunasAfectadas(localCalc)
    }
    if (visibles.length > 0) {
      setGlobalMode(false)
    }
  }, [visibles])

  useEffect(() => {
    const localCalc = calculateComunas(allVisibles)
    if (localCalc !== comunasAfectadas) {
      setAllComunasAfectadas(localCalc)
    }
    if (allVisibles.length > 0) {
      setGlobalMode(true)
    }
  }, [allVisibles])

  const handleTriggerMapChange = node => {
    setTriggeredNode(node)
    setResetMapView(false)
  }

  const handleResetMapView = () => {
    setTriggeredNode(false)
    setResetMapView(true)
  }

  const handleSetMapViewToAllVisibles = () => {
    setTriggeredNode(false)
    setResetMapView(false)
    setMapViewToAllVisibles(true)
  }

  const triggerNode = () => {
    if (triggeredNode) {
      return triggeredNode
    }
  }

  const triggerResetMapView = () => {
    if (resetMapView) {
      return resetMapView
    }
  }

  const triggerMapViewToAllVisibles = () => {
    if (mapViewToAllVisibles) {
      return mapViewToAllVisibles
    }
  }

  return (
    <Wrapper>
      <ColMap>
        <WrapperMap>
          <Map>
            <Numbers
              className="absolute z-10"
              comunas={globalMode ? allComunasAfectadas : comunasAfectadas}
              incidentes={globalMode ? allVisibles.length : visibles.length}
              acumulados={
                globalMode
                  ? allVisibles.length
                  : acumulados.length + visibles.length
              }
              epoca={epoca}
              globalMode={globalMode}
            />
            <Mapa
              nodes={visibles}
              acumulados={acumulados}
              allVisibles={allVisibles}
              triggerFromOutside={triggerNode()}
              resetMapView={triggerResetMapView()}
              onTriggerMapAll={triggerMapViewToAllVisibles()}
            />
          </Map>
        </WrapperMap>
      </ColMap>
      <WrapperScroller>
        <Scroller
          semestres={semestres}
          allVisibles={allVisibles}
          allComunasAfectadas={allComunasAfectadas}
          comunasAfectadas={comunasAfectadas}
          onVisible={handleVisible}
          onAllVisible={handleAllVisible}
          triggerMapChange={handleTriggerMapChange}
          resetMapView={handleResetMapView}
          onTriggerMapAll={handleSetMapViewToAllVisibles}
        />
      </WrapperScroller>
    </Wrapper>
  )
}

export default Composer
